import React from 'react';
import { useI18nContext } from '@ecg-internal/js-react-i18n';

import Styles from './Title.module.scss';

export type TKeyword = 'free' | 'bikes' | 'caravans' | 'campers' | 'playstation';

type TProps = {
  keyword: string;
  [key: string]: unknown;
};

const Title = ({ keyword, ...rest }: TProps) => {
  const { t } = useI18nContext();
  const line1 = t(`popularKeywords.title.${keyword}`);
  const line2 = t('popularKeywords.inYourArea');

  return (
    <h1 {...rest} className={Styles.Wrapper}>
      <span>{line1}</span>
      <span>{line2}</span>
    </h1>
  );
};

export default Title;
